module.exports = __webpack_public_path__ + "static/media/moderna_laperla.a070e9c4.png";